import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const BulletUpperRomanIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "BulletUpperRoman",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M5.47 12.59h.06c.38 0 .73-.09 1.04-.26h-.01c.16-.12.23-.45.23-.97V5.29c0-.51 0-.83-.23-.98a1.83 1.83 0 0 0-.93-.26h-.16V3.8h4.05v.25h-.15c-.34 0-.67.1-.94.26-.17.22-.26.49-.26.79 0 .06 0 .12.01.18s0 6.06 0 6.06c0 .52.09.85.25.98.3.16.65.25 1.03.25h.06v.25H5.47v-.25ZM2 27.89h.06c.38 0 .73-.09 1.04-.26h-.01c.16-.12.23-.45.23-.97v-6.07c0-.51 0-.83-.23-.98a1.83 1.83 0 0 0-.93-.26H2v-.2h4.05v.25H5.9c-.34 0-.67.1-.94.26-.17.22-.26.49-.26.79 0 .06 0 .12.01.18s0 6.06 0 6.06c0 .52.09.85.25.98.3.16.65.25 1.03.25h.06v.25H2.01v-.31Zm4.55 0h.04c.37 0 .73-.09 1.03-.26h-.01c.18-.12.25-.45.25-.97v-6.07c0-.51 0-.83-.25-.98a1.83 1.83 0 0 0-.93-.26h-.14v-.2h4.03v.25h-.12c-.36 0-.69.09-.98.26-.16.14-.23.46-.23.97v6.07c0 .52 0 .85.23.98.31.16.67.25 1.06.25h.02v.25H6.52v-.31Zm22.54-8.72H14.64c-.5 0-.9.4-.9.9s.4.9.9.9h14.45c.5 0 .9-.4.9-.9s-.4-.9-.9-.9m-7.22 5.42h-7.22c-.5 0-.9.4-.9.9s.4.9.9.9h7.22c.5 0 .9-.4.9-.9s-.4-.9-.9-.9M14.65 7.42H29.1c.5 0 .9-.4.9-.9s-.4-.9-.9-.9H14.65c-.5 0-.9.4-.9.9s.4.9.9.9m0 5.42h7.22c.5 0 .9-.4.9-.9s-.4-.9-.9-.9h-7.22c-.5 0-.9.4-.9.9s.4.9.9.9"
      })
    }) : /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M5.71 5H8v8H5.71zM4 19.86h2.29v8H4zM7.43 19.86h2.29v8H7.43zM28 7.29H14.29a1.14 1.14 0 1 1 0-2.28H28a1.14 1.14 0 1 1 0 2.28M21.14 13h-6.86a1.14 1.14 0 1 1 0-2.28h6.86a1.14 1.14 0 1 1 0 2.28M28 22.14H14.29a1.14 1.14 0 1 1 0-2.28H28a1.14 1.14 0 1 1 0 2.28M21.14 27.86h-6.86a1.14 1.14 0 1 1 0-2.28h6.86a1.14 1.14 0 1 1 0 2.28"
      })
    })
  }));
};
BulletUpperRomanIcon.displayName = 'BulletUpperRomanIcon';